module.exports = __webpack_public_path__ + "img/q13.d7b2f41a.png";